import React from 'react';

import { TrashIcon } from '../icons/TrashIcon';
import { FormElement, FormList, FormListItem } from '../CommonFormComponents';
import '../../styles/organisms/worker-registration-application-form-upload.scss';

export const WorkerRegistrationApplicationFormUpload = ({
  disabled,
  formValues,
  errors,
  onFileChange,
  onFileDelete,
  onFileClick,
}) => {
  return (
    <div className='WorkerRegistrationApplicationFormUpload'>
      <FormList>
        <FormListItem label='作業員名簿データの添付' required>
          <FormElement
            validate={errors.fileName}
            info='※1申請につき1つのファイルのみ添付できます'
          >
            <div className='form-container'>
              {formValues.fileName && (
                <div className='WorkerRegistrationApplicationFormUpload__input-filename'>
                  <span>{formValues.fileName}</span>
                  <div>
                    {/* IEのflexbox不具合対策 */}
                    <button
                      className='btn-icon--xs sys-delete form-list__element--btn_delete'
                      onClick={onFileDelete}
                    >
                      <TrashIcon className='icon--2_4x form-list__trash-icon' />
                    </button>
                  </div>
                </div>
              )}
              <div className='form-container__item'>
                <label
                  htmlFor='file'
                  className={`btn-fixedsize ${
                    disabled ? 'btn-fixedsize--disabled' : 'input-file'
                  }`}
                >
                  ファイル選択
                  <input
                    id='file'
                    type='file'
                    accept='application/pdf'
                    onChange={onFileChange}
                    onClick={onFileClick}
                  />
                </label>
              </div>
            </div>
          </FormElement>
        </FormListItem>
      </FormList>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/forms/WorkerRegistrationApplicationFormUpload.jsx